// import './App.css';
import Path from './routes/Path';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap';

function App() {
  return (
    <div style={{ overflow:'hidden' }}>
      <Path/>
    </div>
  );
}

export default App;
